import React from 'react';
import type { WorkspaceMode } from '@auw/workspace-utils';
import { WorkspaceModeChrome } from './WorkspaceModeChrome';
import { WorkspaceModeContent } from './WorkspaceModeContent';

interface WorkspaceRouteLayoutProps {
  readonly mode: WorkspaceMode;
  readonly docAgentView?: 'auto' | 'landing' | 'editor';
}

const WorkspaceRouteLayout: React.FC<WorkspaceRouteLayoutProps> = ({
  mode,
  docAgentView,
}) => (
  <WorkspaceModeChrome mode={mode}>
    {({ inputSlot }) => (
      <WorkspaceModeContent
        mode={mode}
        inputSlot={inputSlot}
        docAgentView={docAgentView}
      />
    )}
  </WorkspaceModeChrome>
);

export const AgentLayout: React.FC = () => <WorkspaceRouteLayout mode="agent" />;
export const LiveAgentLayout: React.FC = () => <WorkspaceRouteLayout mode="live-agent" />;
export const DocumentLayout: React.FC = () => <WorkspaceRouteLayout mode="document" />;
export const DocAgentLandingLayout: React.FC = () => (
  <WorkspaceRouteLayout mode="doc-agent" docAgentView="landing" />
);
export const DocAgentEditorLayout: React.FC = () => (
  <WorkspaceRouteLayout mode="doc-agent" docAgentView="editor" />
);
export const StorageLayout: React.FC = () => <WorkspaceRouteLayout mode="storage" />;
export const MessageLayout: React.FC = () => <WorkspaceRouteLayout mode="message" />;
export const WidgetLayout: React.FC = () => <WorkspaceRouteLayout mode="widget" />;
export const FeedLayout: React.FC = () => <WorkspaceRouteLayout mode="feed" />;
export const ToolsLayout: React.FC = () => <WorkspaceRouteLayout mode="tools" />;
export const AppManageLayout: React.FC = () => <WorkspaceRouteLayout mode="app-manage" />;
export const AdminLayout: React.FC = () => <WorkspaceRouteLayout mode="admin-page" />;
export const PluginLayout: React.FC = () => <WorkspaceRouteLayout mode="plugin" />;
export const SkillCreateLayout: React.FC = () => <WorkspaceRouteLayout mode="skill-create" />;
